import React, { useState } from 'react';

function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setError('');
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      if (!res.ok) {
        if (res.status === 401) {
          setError('Invalid email or password');
        } else {
          setError('Error logging in. Please try again.');
        }
        setLoading(false);
        return;
      }
      const data = await res.json();
      if (data && data.token) {
        onLogin(data.token);
      } else {
        setError('Login failed. No token received.');
        setLoading(false);
      }
    } catch (err) {
      setError('Unable to connect to server');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-gray-900 transition-colors">
      <div className="w-full max-w-md bg-white dark:bg-gray-800 rounded-lg shadow p-8">
        <div className="text-center mb-6">
          <img src="/logo-blue.png" alt="Tambola" className="h-12 mx-auto dark:hidden" />
          <img src="/logo-white.png" alt="Tambola" className="h-12 mx-auto hidden dark:block" />
          <h2 className="text-2xl font-bold mt-2">Download Dashboard</h2>
        </div>
        <form onSubmit={handleSubmit}>
          <input 
            type="email" 
            className="w-full px-4 py-2 mb-3 rounded border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand" 
            placeholder="Email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)} 
            required 
          />
          <input 
            type="password" 
            className="w-full px-4 py-2 mb-3 rounded border border-gray-300 dark:border-gray-700 bg-gray-50 dark:bg-gray-700 text-gray-800 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-brand" 
            placeholder="Password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
          />
          {error && <p className="text-red-500 text-sm mb-3">{error}</p>}
          <button 
            type="submit" 
            className={`w-full py-2 px-4 rounded bg-brand text-white font-semibold transition-opacity ${loading ? 'opacity-50 cursor-not-allowed' : 'hover:opacity-90'}`}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;

